import { render, staticRenderFns } from "./EmployeeOptIn.vue?vue&type=template&id=0f05188e&"
import script from "./EmployeeOptIn.vue?vue&type=script&lang=js&"
export * from "./EmployeeOptIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports